package com.example.readingnotes.presentation.auth

sealed interface AuthEvent {
    // Existing events
    data class OnPasswordChanged(
        val text: String,
    ) : AuthEvent

    data object OnLoginSubmit : AuthEvent

    data object OnLogout : AuthEvent

    data object OnCheckAuthState : AuthEvent

    // New events for username authentication
    data class OnUsernameChanged(
        val text: String,
    ) : AuthEvent

    data object OnRegisterSubmit : AuthEvent

    data object OnLoginWithUsernameSubmit : AuthEvent

    // TOTP events
    data class OnTotpCodeChanged(
        val code: String,
    ) : AuthEvent

    data object OnVerifyTotpSubmit : AuthEvent

    data object OnSetupTotp : AuthEvent

    // Email authentication events
    data class OnEmailChanged(
        val email: String,
    ) : AuthEvent

    data class OnVerificationCodeChanged(
        val code: String,
    ) : AuthEvent

    data object OnSendVerificationCode : AuthEvent

    data object OnVerifyEmailSubmit : AuthEvent

    data object OnLoginWithEmailSubmit : AuthEvent

    // Username availability check
    data class OnCheckUsername(
        val username: String,
    ) : AuthEvent

    // Complete registration with username and password
    data object OnCompleteRegistration : AuthEvent
}
